import React from "react";
import { push as Menu } from "react-burger-menu";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Item from "./Item";
import ItemExternal from "./ItemExternal";

import ManpowerLogo from "../../../assets/images/logos/MPG_BE_Logo_SS_HOR_MC_RGB_REG.png";

const Sidebar = ({
  isOpen,
  outerContainerId,
  pageWrapId,
  setActiveSidebar,
  items,
  setSsoRefreshTokenModal,
  refreshToken,
}) => {
  const isMenuOpen = (state) => {
    setActiveSidebar(state.isOpen);
  };
  const { t } = useTranslation();

  return (
    <Menu
      customBurgerIcon={false}
      isOpen={isOpen}
      outerContainerId={outerContainerId}
      pageWrapId={pageWrapId}
      noOverlay
      width={250}
      onStateChange={isMenuOpen}
      className=""
    >
      <Link
        to={"/"}
        className="list-group-item border-0 text-decoration-none py-4 text-center"
        style={{ color: "inherit" }}
      >
        <img src={ManpowerLogo} alt="menu-logo" className="menu-logo" />
      </Link>

      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.external ? (
            <ItemExternal
              key={index}
              item={item}
              setSsoRefreshTokenModal={setSsoRefreshTokenModal}
              setActiveSidebar={setActiveSidebar}
              refreshToken={refreshToken}
            />
          ) : (
            <Item key={index} item={item} t={t} />
          )}
        </React.Fragment>
      ))}
    </Menu>
  );
};

export default Sidebar;
